import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { useToastSeeker } from "@app"
import { deleteSubmit, getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, SERVICES_TYPE } from "@constants"
import { isLoadingUserSettingProvidersData, userSettingProvidersData, userSettingProvidersFormData, isEditUserSettingsProvidersDrawer } from "../@signals"


export default function useUserSettingsProvider(rowData={}) {
	const { showToast } = useToastSeeker()
	const isLoading = useSignal(false)

	const getProviderData = useCallback(() => {
		getSubmit(`${BACKEND_APIS.CRUD}/user/provider_color`)
			.then(data => userSettingProvidersData.value = data)
			.catch(() => {
				showToast.error()
				userSettingProvidersData.value = []
			}).finally(() => isLoadingUserSettingProvidersData.value = false)
	}, [])

	const handleSetProviderFormData = useCallback(() => userSettingProvidersFormData.value = {
		id: rowData.id || null,
		color: rowData.color,
		id_provider: rowData.id_provider || null,
		service_type: SERVICES_TYPE.PROVIDER_COLOR
	}, [JSON.stringify(rowData)])

	const handleChangeProviderFormData = useCallback((newValue, prop) => userSettingProvidersFormData.value = {
		...userSettingProvidersFormData.value,
		[prop]: newValue
	}, [])

	const handleSubmitProviderFormData = useCallback(() => {
		isLoading.value = true
		postSubmit(`${BACKEND_APIS.CRUD}/${!isEditUserSettingsProvidersDrawer.value ? 'add' : 'update'}`, userSettingProvidersFormData.value).then(res => {
			if (isEditUserSettingsProvidersDrawer.value) {
				userSettingProvidersData.value = [
					...userSettingProvidersData.value.map(item => item.id === userSettingProvidersFormData.value.id ? res : item)
				]
			} else {
				userSettingProvidersData.value = [
					...userSettingProvidersData.value,
					res
				]
			}
			userSettingProvidersFormData.value = {}
		}).catch(() => showToast.error())
			.finally(() => isLoading.value = false)
	}, [])

	const handleDeleteProvider = useCallback(() => showToast.confirm(`Are you sure you want to delete this row? This action cannot be undone.`, {
		onSubmit: () => {
			isLoading.value = true
			deleteSubmit(`${BACKEND_APIS.CRUD}/delete/${SERVICES_TYPE.PROVIDER_COLOR}?id=${rowData.id}`).then(() => {
				userSettingProvidersData.value = [
					...userSettingProvidersData.value.filter(item => item.id !== rowData.id)
				]
			}).catch(() => showToast.error())
				.finally(() => isLoading.value = false)
		}
	}), [JSON.stringify(rowData)])

	return {
		isClicked: rowData.id === userSettingProvidersFormData.value.id,
		isLoading: isLoading.value,
		getProviderData,
		handleSetProviderFormData,
		handleChangeProviderFormData,
		handleSubmitProviderFormData,
		handleDeleteProvider
	}
}